// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__21VPR","actionCircle":"style_actionCircle__ydk0o","actionCircleRed":"style_actionCircleRed__1kat4"};